var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMvideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 152 152"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
  id: "mvideo_svg__defs28"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "mvideo_svg__Nepojmenovan\\xFD_p\\u0159echod_13",
  x1: 32.46,
  x2: 150.49,
  y1: 52.51,
  y2: 133.3,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  id: "mvideo_svg__stop7",
  offset: 0,
  stopColor: "#0091ea"
}), /*#__PURE__*/React.createElement("stop", {
  id: "mvideo_svg__stop9",
  offset: 1,
  stopColor: "#00cafe"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mvideo_svg__gr",
  x1: 20.41,
  x2: 56.55,
  y1: 143.29,
  y2: 50.17,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  id: "mvideo_svg__stop15",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  id: "mvideo_svg__stop17",
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "mvideo_svg__clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "mvideo_svg__rect4",
  width: 152,
  height: 152,
  x: 20,
  y: 20,
  fill: "none",
  className: "mvideo_svg__cls-1",
  rx: 12,
  ry: 12
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "mvideo_svg__clip-path-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "mvideo_svg__rect12",
  fill: "none",
  d: "M20 20h152v152H20z",
  className: "mvideo_svg__cls-1"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "mvideo_svg__radial-gradient",
  cx: 23.77,
  cy: 23.93,
  r: 204.62,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  id: "mvideo_svg__stop20",
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  id: "mvideo_svg__stop22",
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("symbol", {
  id: "mvideo_svg__material_product_icon_border",
  "data-name": "material_product_icon_border",
  viewBox: "0 0 192 192"
}, /*#__PURE__*/React.createElement("path", {
  id: "mvideo_svg__rect25",
  fill: "none",
  d: "M0 0h192v192H0z",
  className: "mvideo_svg__cls-1"
})), /*#__PURE__*/React.createElement("style", {
  id: "style2"
}, ".mvideo_svg__cls-1{fill:none}"))), /*#__PURE__*/React.createElement("g", {
  id: "mvideo_svg__back",
  transform: "translate(-20 -20)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "mvideo_svg__rect32",
  width: 152,
  height: 152,
  x: 20,
  y: 20,
  rx: 12,
  ry: 12,
  style: {
    fill: "#e0e0e0"
  }
}), /*#__PURE__*/React.createElement("g", {
  id: "mvideo_svg__g42",
  style: {
    clipPath: "url(#mvideo_svg__clip-path)"
  }
}, /*#__PURE__*/React.createElement("path", {
  id: "mvideo_svg__rect34",
  d: "M20 20h152v152H20z",
  style: {
    fill: "url(#mvideo_svg__Nepojmenovan\xFD_p\u0159echod_13)"
  }
}), /*#__PURE__*/React.createElement("g", {
  id: "mvideo_svg__g38",
  style: {
    clipPath: "url(#mvideo_svg__clip-path-2)"
  }
}, /*#__PURE__*/React.createElement("path", {
  id: "mvideo_svg__polygon36",
  d: "m20 183.26-59.68-52.75 34.3-148.37L68.64 5.75l54.43 100.65z",
  style: {
    opacity: 0.2,
    fill: "url(#mvideo_svg__gr)"
  }
})), /*#__PURE__*/React.createElement("path", {
  id: "mvideo_svg__path40",
  d: "M124.65 86.92 86.88 58.75a11.26 11.26 0 0 0-6.78-2.29 11.43 11.43 0 0 0-11.46 11.45v56.33a11.43 11.43 0 0 0 11.46 11.43 11.26 11.26 0 0 0 6.78-2.29l37.76-28.16a11.42 11.42 0 0 0 .01-18.3m-25.77 20.9a1.62 1.62 0 0 1-1.59 1.92h-7.8a1.62 1.62 0 0 1-1.59-1.92l2.24-11.76a6.29 6.29 0 0 1-3.45-5.13 7.22 7.22 0 0 1 6.83-8.38 6.88 6.88 0 0 1 6.9 7 7 7 0 0 1-3.78 6.51z",
  style: {
    fill: "#fff"
  }
}))), /*#__PURE__*/React.createElement("g", {
  id: "mvideo_svg__back_edge",
  "data-name": "back, edge"
}, /*#__PURE__*/React.createElement("path", {
  id: "mvideo_svg__path45",
  d: "M140 0H12A12 12 0 0 0 0 12v1A12 12 0 0 1 12 1h128a12 12 0 0 1 12 12v-1a12 12 0 0 0-12-12",
  style: {
    fill: "#fff",
    fillOpacity: 0.2
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "mvideo_svg__path47",
  d: "M140 152H12a12 12 0 0 1-12-12v-1a12 12 0 0 0 12 12h128a12 12 0 0 0 12-12v1a12 12 0 0 1-12 12",
  style: {
    fill: "#212121",
    fillOpacity: 0.1
  }
})), /*#__PURE__*/React.createElement("g", {
  id: "mvideo_svg__finish",
  transform: "translate(-20 -20)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "mvideo_svg__rect50",
  width: 152,
  height: 152,
  x: 20,
  y: 20,
  rx: 12,
  ry: 12,
  style: {
    fill: "url(#mvideo_svg__radial-gradient)"
  }
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "mvideo_svg__border",
  transform: "translate(-20 -20)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mvideo_svg__material_product_icon_border",
  id: "mvideo_svg__use53",
  width: 192,
  height: 192
}))));
export { SvgMvideo as ReactComponent };
export default "data:image/svg+xml;base64,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";